import React, {Component} from 'react';
import {
    withRouter
} from "react-router-dom";
import './taskbar.scss';
import firebase from "firebase";
import $ from 'jquery';
import {withTranslation} from "react-i18next";

class Taskbar extends Component {
    constructor(props) {
        super(props);

        this.state = {
            time: "",
            startOpen: false
        }
    }

    componentDidMount() {
        $(document).ready(() => {
            let w = window.innerWidth;

            if(w > 800) {
                $("#start-menu").toggle('hide');
            }

            $("#home-button").click(function () {
                $("#start-menu").toggle('hide');
            });
        });
        setInterval(this.updateClock, 1000);
    }

    hide(id) {
        let x = document.querySelector(id);
        if(x && x.style) {
            if (x.style.visibility === "hidden") {
                x.style.visibility = "visible";
            } else {
                x.style.visibility = "hidden";
            }
        }
    }

    logoutUser = () => {
        this.props.history.push('/login/' + localStorage.getItem('code'));
    };

    updateClock = () => {
        let currentTime = new Date();
        let currentHours = currentTime.getHours();
        let currentMinutes = currentTime.getMinutes();

        currentMinutes = (currentMinutes < 10 ? "0" : "") + currentMinutes;

        let timeOfDay = (currentHours < 12) ? "AM" : "PM";

        currentHours = (currentHours > 12) ? currentHours - 12 : currentHours;
        currentHours = (currentHours === 0) ? 12 : currentHours;

        let currentTimeString = currentHours + ":" + currentMinutes + " " + timeOfDay;
        this.setState({time: currentTimeString})

    }

    openStory = (id) => {
        const { openStory } = this.props;
        $("#start-menu").toggle('hide');

        if(!$(".imageBox").is(':visible')) {
            this.hide(".imageBox")
        }

        if(!$(".storyBox").is(':visible')) {
            this.hide(".storyBox")
        }

        openStory(id);
    };

    renderStoryButtons = (stories, currentStory, i18n) => {
        const {finished} = this.props;
        const dots = '...................................................';

        if (stories) {
            return stories.map(story => {
                const available = story.date && story.date.seconds && story.date.seconds < new Date().getTime() / 1000;
                return(
                    <li key={story.id} onClick={() => {
                        if (available) {
                            this.openStory(story.id);
                        }
                    }} className={"start-menu-item" + (!available ? " disabled" : "")}><i
                        class={"fa fa-file"}></i><span className={!available ? "unavailable" : ""}>{(available ? (i18n.language === "en-US" ? story.title_en : story.title) : "Wordt beschikbaar op:") + (!available ? (story.date && story.date.seconds ? new Date(story.date.seconds * 1000 ).toLocaleDateString() : "") : "")}
                    </span>
                        </li>
                )
            })
        }
    };

    render() {
        const {time} = this.state;
        const {currentStory, videos, images, t, i18n, stories, description, videoTitle} = this.props;
        const hasImages =  images.length > 0;
        const hasVideos =  videos.length > 0;

        return (
            <div className="taskbar" id="taskbar">
                <div id="home-button"><i class="far fa-circle"></i></div>
                {currentStory ? <>
                    {description ? <div onClick={() => {
                        this.hide(".storyBox")
                    }} className="storyBtn">{i18n.language === "en-US" ? (currentStory.title_en ? currentStory.title_en : "") : (currentStory.title ? currentStory.title : "")}</div> : null}
                    {hasImages ?
                        images.map((image, index) => {
                            return (
                                <div onClick={() => {
                                    this.hide(`#image${index}`)
                                }} className="storyBtn">{i18n.language === "en-US" ? (image.title_en ? image.title_en : "") : (image.title_nl ? image.title_nl : "")}</div>
                            )
                        }) : null}
                    {hasVideos ?
                        videos.map((video, index) => {
                            return (
                                <div onClick={() => {
                                    this.hide(`#video${index}`)
                                }} className="storyBtn">{i18n.language === "en-US" ? (video.videoTitle_en ? video.videoTitle_en : "") : (video.videoTitle_nl ? video.videoTitle_nl : "")}</div>
                            )
                        }) : null}
                </> : null}
                <div class="taskbar-tools">
                    <div id="time">{time}</div>
                    <div id="wifi"><i class="fa fa-wifi"></i></div>
                    <div id="battery"><i class="fa fa-battery-three-quarters"></i></div>
                </div>

                <div id="start-menu">
                    <div id="settings">
                        <ul>
                            <li onClick={() => this.logoutUser()} class="settings-item"><i class="fa fa-power-off"></i>
                            </li>
                        </ul>
                    </div>

                    <ul>
                        {this.renderStoryButtons(stories, currentStory, i18n)}
                    </ul>
                </div>
            </div>
        );
    }

}
;

export default withRouter(withTranslation()(Taskbar));
